import { LinkProps } from "next/dist/client/link";
import Link from "next/link";
import React from "react";
import styles from "./salify-link.module.css";

export interface SalifyLinkProps extends React.PropsWithChildren<LinkProps> {
  className?: string;
  style?: React.StyleHTMLAttributes<HTMLAnchorElement>;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}

const SalifyLink: React.FC<SalifyLinkProps> = ({ ...props }) => {
  return <Link className={styles.link} {...props} />;
};

export default SalifyLink;
